import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';
import { TypographyFontFamily, TypographyFontSize } from '@design-system/components/atoms/typography/entities/typography.types';
import {
  ButtonLinkIconPosition, ButtonLinkType
} from '@design-system/components/molecules/button-link/entities/button-link.types';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';

@Component({
  selector: 'app-ds-button-link',
  templateUrl: './button-link.component.html',
  styleUrls: ['./button-link.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    TypographyDsComponent,
    IconDsComponent,
  ]
})
export class ButtonLinkDsComponent {

  @Input() type = ButtonLinkType.Primary;
  @Input() fontSize = TypographyFontSize.XXS;
  @Input() iconPosition = ButtonLinkIconPosition.Left;
  @Input() isDisabled = false;
  @Input() icon: Icon = null;
  @Input() iconSize = 24;
  @Input() label = '';

  @Output() clickEvent: EventEmitter<void> = new EventEmitter<void>();

  public readonly fontFamily = TypographyFontFamily.SemiBold;

  constructor() { }

}
